//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import "@/mixins/global";
import chartOTP from "../components/chartOTP";
import axios, { CancelToken } from "axios";
import ChartOTP from "../components/chartOTP.vue";
export default {
  components: {
    chartOTP,
  },
  data() {
    return {
      chartVNDoc: {
        ALL: [],
        NYV11: [],
        NYV12: [],
        NYV13: [],
        TLA22: [],
        TVN21: [],
      },
      chartVNSample: {
        ALL: [],
        NYV11: [],
        NYV12: [],
        NYV13: [],
        TLA22: [],
        TVN21: [],
      },

      ps: "202040",
      pe: "202052",
      apivn_doc: `${this.$apiFix}OTP_VN.php/doc`, //"http://localhost:9000/nygcontrolroom/OTP_VN.php/doc",
      apivn_sample:  `${this.$apiFix}OTP_VN.php/sample`, //"http://localhost:9000/nygcontrolroom/OTP_VN.php/sample",
    };
  },
  async mounted() {
    this.vnDoc();
    this.vnSample();
  },
  methods: {
    goPage(routerName) {
      this.$router.push({
        name: routerName,
      });
    },

    vnDoc() {
      axios
        .get(`${this.apivn_doc}?ps=${this.ps}&pe=${this.pe}&team=`)
        .then((response) => {
          this.chartVNDoc.ALL = response.data;
        });
      axios
        .get(`${this.apivn_doc}?ps=${this.ps}&pe=${this.pe}&team=NYV1-1`)
        .then((response) => {
          this.chartVNDoc.NYV11 = response.data;
        });
      axios
        .get(`${this.apivn_doc}?ps=${this.ps}&pe=${this.pe}&team=NYV1-2`)
        .then((response) => {
          this.chartVNDoc.NYV12 = response.data;
        });
      axios
        .get(`${this.apivn_doc}?ps=${this.ps}&pe=${this.pe}&team=NYV1-3`)
        .then((response) => {
          this.chartVNDoc.NYV13 = response.data;
        });
      axios
        .get(`${this.apivn_doc}?ps=${this.ps}&pe=${this.pe}&team=TLA2-2`)
        .then((response) => {
          this.chartVNDoc.TLA22 = response.data;
        });
      axios
        .get(`${this.apivn_doc}?ps=${this.ps}&pe=${this.pe}&team=TVN2-1`)
        .then((response) => {
          this.chartVNDoc.TVN21 = response.data;
        });
    },
    vnSample() {
      axios
        .get(`${this.apivn_sample}?ps=${this.ps}&pe=${this.pe}&team=`)
        .then((response) => {
          this.chartVNSample.ALL = response.data;
        });
      axios
        .get(`${this.apivn_sample}?ps=${this.ps}&pe=${this.pe}&team=NYV1-1`)
        .then((response) => {
          this.chartVNSample.NYV11 = response.data;
        });
      axios
        .get(`${this.apivn_sample}?ps=${this.ps}&pe=${this.pe}&team=NYV1-2`)
        .then((response) => {
          this.chartVNSample.NYV12 = response.data;
        });
      axios
        .get(`${this.apivn_sample}?ps=${this.ps}&pe=${this.pe}&team=NYV1-3`)
        .then((response) => {
          this.chartVNSample.NYV13 = response.data;
        });
      axios
        .get(`${this.apivn_sample}?ps=${this.ps}&pe=${this.pe}&team=TLA2-2`)
        .then((response) => {
          this.chartVNSample.TLA22 = response.data;
        });
      axios
        .get(`${this.apivn_sample}?ps=${this.ps}&pe=${this.pe}&team=TVN2-1`)
        .then((response) => {
          this.chartVNSample.TVN21 = response.data;
        });
    },
  },
};
